import { useFootnoteOpenState } from '~/composables/footnotes/useFootnotesOpenSate'

/**
 * Composable for managing journal footnotes. Uses footnotes in the journal article fetched from Solr, and provides methods to open and close footnotes.
 *
 * @param footnotes - The footnotes in the journal article
 */
export function useJournalFootnotes(footnotes: MaybeRefOrGetter<{ footnoteId?: string, bodytext?: string }[] | undefined>) {
  const { openState, open, close } = useFootnoteOpenState()

  const { $parseStringToDocument } = useNuxtApp()

  return {
    open,
    close,
    data: computed(
      () => (toValue(footnotes) ?? []).reduce<FootnotesState>((acc, f) => {
        if (!f.footnoteId) {
          return acc
        }

        const document = $parseStringToDocument(f.bodytext ?? '', ['create-journal-footnote-content'])

        acc[f.footnoteId] = {
          content: document,
          open: openState.get(f.footnoteId) ?? false,
        }

        return acc
      }, {}),
    ),
  }
}
